import { UInt } from '../base/UInt.js';
/**
 * @name u32
 * @description
 * A 32-bit unsigned integer
 */
export class u32 extends UInt.with(32) {
    constructor() {
        super(...arguments);
        // NOTE without this, we cannot properly determine extensions
        this.__UIntType = 'u32';
    }
}
